import React from "react";
import { PanelGroup, Panel } from "../../compat/PanelCompat";
import ZonesActive from '../../../../image/Icons/Zones-active.png'
import ReportBundlePackageZones from './reportBundlePackageZones'

export default class ReportBundleProductPackageConfiguration extends React.Component{
  constructor(props){
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.onGeographyClickAction = this.onGeographyClickAction.bind(this);
    this.onSelectingReportBundleGeography = this.props.onSelectingReportBundleGeography.bind(this);


    this.state = {
      mobile: false,
      activeKey: '1'
    };
  }

  componentDidMount() {
    if(/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent) ){
      this.setState({
        mobile: true,
       });
    }
  }

  /* istanbul ignore next */
  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  /* istanbul ignore next */
  onGeographyClickAction(){
    this.setState({
      activeKey: '2'
    });
  }

  render(props){
    let classNames = require('classnames');
    let headerSpacing = classNames({
      "row margin-top-160": this.state.mobile === false,
      "row": this.state.mobile === true
    });
    return (
      <div>
      <div className="row no-margin">
        <div className="col-sm-12">
          <div className={headerSpacing}>
            {/* <div className="back-btn" onClick={history.goBack}> &lt; Back </div>
            <hr/> */}
          </div>
          <div className="row">
            <div className="section-no-pad-title text-center">Customise Your Subscription</div>
          </div>
        </div>
      </div>
      <div className="row white-bg padding-20 margin-10">
        <div className="col-sm-12 no-padding">
          <PanelGroup
            accordion
            id="report-bundle-config-accordion"
            activeKey={this.state.activeKey}
            onSelect={this.handleSelect}
          >
            <Panel eventKey="1">
              <Panel.Heading  className="white-bg">
                <Panel.Title toggle>
                  <div type="button" className="row panel-title panel-button no-margin">
                    <div className="col-xs-8 text-left font-14 no-padding">
                      <span><img src={ZonesActive} alt="" className="margin-right-5"/>
                        <span className="text-success">
                          Top Performing Suburb Region
                        </span>
                      </span>
                    </div>
                    <div className="col-xs-4 text-right no-padding font-14">
                      <span>
                        {
                          this.props.productPackageDefaultConfig &&
                          this.props.productPackageDefaultConfig.configuration.geography.states!=null &&
                          this.props.productPackageDefaultConfig.configuration.geography.states.map(function(state,index){
                            return(
                              <span className="text-success" key={index}>{state}.</span>
                            )
                          })
                        }
                      </span>
                      {this.state.activeKey!=='1' &&
                        <span className="carat-up text-success" aria-hidden="true"></span>
                      }
                      {this.state.activeKey==='1' &&
                        <span className="carat-down text-success" aria-hidden="true"></span>
                      }
                    </div>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                {
                  this.props.productPackageDefaultConfig &&
                  this.props.productPackageDefaultConfig.configuration.packageName &&
                  <ReportBundlePackageZones
                    geography={this.props.productPackageConfig.packages[this.props.productPackageDefaultConfig.configuration.packageName].geography}
                    selectedGeography={this.props.productPackageDefaultConfig.configuration.geography}
                    selectedPackage={this.props.productPackageDefaultConfig.configuration.packageName}
                    onSelectingReportBundleGeography = {this.onSelectingReportBundleGeography}
                    onGeographyClickAction = {this.onGeographyClickAction}
                  />
                }

              </Panel.Body>
            </Panel>
          </PanelGroup>
        </div>
      </div>
    </div>
    )
  }
}
